import { request, getApiUrl } from '@/utils/ajax';
import { BuyerOffer } from '@/types';

export function getBuyerOffer(buyerOfferId: number): Promise<BuyerOffer> {
    return request(`api/buyer-offer/${buyerOfferId}`, {}).then((x) => x.json());
}

export function getDownloadBuyerOfferAttachmentUrl(attachmentId: number) {
    return getApiUrl() + `/api/buyer-offer-attachment/${attachmentId}/attachment/download`;
}

export function getOpenBuyerOfferAttachmentUrl(attachmentId: number) {
    return getApiUrl() + `/api/buyer-offer-attachment/${attachmentId}/attachment/open`;
}

export function getBuyerOfferAttachmentThumbnailUrl(attachmentId: number) {
    return getApiUrl() + `/api/buyer-offer-attachment/${attachmentId}/attachment/thumbnail`;
}
